import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";
import { Add, Edit, Refresh } from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";

export default function TableGoals({
  data,
  loading,
  onAction,
  onResearch,
  currentPage,
  currentSizePerPage,
  totalRegistros,
  onTableChange,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Periodo",
      text: "Período",
      align: "center",
    }),
    columnTextField({
      dataField: "Loja",
      text: "Loja",
      align: "center",
    }),
    columnTextField({
      dataField: "MetaLoja",
      text: "Meta da Loja",
      align: "center",
    }),
    columnTextField({
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Editar Meta">
            <IconButton
              size="small"
              aria-label="edit"
              onClick={() => onAction("edit", row)}
            >
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <div>
      {data.length > 0 ? (
        <ToolkitTable
          keyField="IdMeta"
          dataTable={data}
          columnModel={columnModel}
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          headerTitle="Metas"
          CustomHeader={() => (
            <Grid
              container
              justify="space-between"
              spacing={2}
              style={{ padding: "0 20px 20px 20px" }}
            >
              <Grid item justify="center">
                <Grid container spacing={2}>
                  <Typography>Metas</Typography>
                  <IconButton
                    size="small"
                    aria-label="edit"
                    onClick={onResearch}
                  >
                    <Refresh fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                onClick={() => onAction("create")}
                disabled={loading}
              >
                <Add /> Criar
              </Button>
            </Grid>
          )}
          pagination={{
            options: [25, 50, 100],
            totalSize: totalRegistros,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: currentSizePerPage,
            showTotal: true,
          }}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
        />
      ) : (
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            color="default"
            variant="contained"
            onClick={() => onAction("create")}
            style={{ marginTop: 20 }}
          >
            Criar
          </Button>
        </Box>
      )}
    </div>
  );
}
